angular.module('mapes').controller('MainCtrl', async (
  $scope,
  $rootScope,
  $uibModal,
  Configuracio,
  DataService,
  Centres,
  CentresPreinscripcio,
  Comarques,
  Municipis,
  Districtes,
  ServeisTerritorials,
  Nivells,
  NotificationsService,
  SharedProperties,
  EnsenyamentsData,
  ServeisEducatius,
  _
) => {
  $scope.cars = [];
  $scope.nivells = {};
  $scope.isUrl = false;
  $scope.ariFilter = [];
  $scope.selectedTab = -1;
  $rootScope.selectedTab = -1;
  $scope.hiHaPreinscripcio = false;
  $scope.selectedPreinscripcioTab = 0;
  $scope.selectedMapTab = 0;
  $scope.pestanya = '';
  $rootScope.isSearching = false;
  $rootScope.cercaClick = false;
  $rootScope.familiaFP = false;

  //Variable provinent del mapa, per la llista d'equipaments seleccionats.
  //TODO: Extreure-ho en un component el mapa
  $scope.dataFromMap = {};

  DataService.getData();

  const configuracio = await Configuracio.init();
  $scope.configuracio = configuracio;
  $rootScope.pilotoOcultacioInclusiva = $scope.configuracio.pilotoOcultacioInclusiva;
  $scope.anyActual = parseInt(configuracio.anyActual);
  $scope.cursos = [$scope.anyActual, $scope.anyActual + 1];
  if ($scope.configuracio.progEnabled === '1') {
    const cursPreinscripcio = +($scope.configuracio.cursPreinscripcio || '').split(' - ')[0];
    $scope.seleccioCurs = cursPreinscripcio ? [cursPreinscripcio] : [$scope.anyActual];
  } else {
    $scope.seleccioCurs = [$scope.anyActual];
  }
  cursSQLQuotes($scope.seleccioCurs);
  $scope.selTipusEnsenyament = [];
  $scope.selNaturalesa = [];
  $scope.selNivell = [];
  params = $scope.configuracio;
  mapesOl.setParams(params);
  mapesOl.setParams($scope.configuracio);
  mapesOl.onLoad();
  $scope.totalItems = '';
  $scope.lastMatchesFromNameInput = null;

  Comarques.init().then((comarques) => {
    $scope.comarques = comarques;
  });
  Municipis.init().then((municipis) => {
    $scope.municipis = municipis;
  });
  ServeisTerritorials.init().then((serveisTerritorials) => {
    $scope.serveisTerritorials = serveisTerritorials;
  });
  Districtes.init().then((districtes) => {
    $scope.districtes = districtes;
  });
  Nivells.init().then(function (nivells) {
    castCursosToNivells(nivells);
    var length = nivells.length;
    $scope.hiHaPreinscripcio = length > 0;
    $scope.selectedTab = $scope.hiHaPreinscripcio ? 0 : 1;
    $rootScope.selectedTab = $scope.hiHaPreinscripcio ? 0 : 1;
  });

  //Funcions auxiliars
  function castCursosToNivells(nivells) {
    for (var i = 0; i < nivells.length; i++) {
      var resArray = nivells[i].cursos.split(",");
      var cursos = [];
      if (nivells[i].codiEnsenyament === 'EINFLOE3-6') {
        aux = 3;
        resArray.forEach(function (item, index) {
          cursos.push({ curso: 'I' + aux, id: index + 1 });
          aux++;
        });
      } else {
        resArray.forEach(function (item, index) {
          cursos.push({ curso: item.toLowerCase(), id: index + 1 })
        });
      }
      $scope.nivells[nivells[i].codiEnsenyament] = cursos;
    }
  }

  $scope.torn = [{ id: 1, name: 'Diürn' }, { id: 2, name: 'Nocturn' }];

  $scope.$on('searchDone', function () {
    $scope.totalItems = SharedProperties.getNumResults();
  });

  $scope.$on('searchInit', function () {
    $("#cercaBtnList").removeClass('is-open');
    $("#cercaBtn").removeClass('is-open');
    $("#cercaAvancada").hide();
    $("#cercaAvancadaList").hide();
  });

  //Funcions per interactuar amb el front
  $scope.changeTab = (value) => {
    $scope.selectedTab = value;
    $rootScope.selectedTab = value;
    $scope.selectedMapTab = 0;
    $rootScope.$broadcast('clear');
    $('#map').empty();
    mapesOl.onLoad();
  };

  angular.extend($scope, DataService.getData());

  $scope.toggleSeleccio = function toggleSeleccio(curs) {
    var idx = $scope.seleccioCurs.indexOf(curs);

    if (idx > -1) {
      $scope.seleccioCurs.splice(idx, 1);
    }
    else {
      $scope.seleccioCurs.push(curs);
    }
    //Per a posar les cometes simples de cara a la crida SQL
    cursSQLQuotes($scope.seleccioCurs);
  };

  //Conversió de Int a format string pel WHERE IN () de SQL
  function cursSQLQuotes(el) {
    var intToStringSeleccioCurs = [];
    el.forEach(function (item) {
      intToStringSeleccioCurs.push("'" + item.toString() + "'");
    });
    //Ho mantenim al servei de propietats compartides entre controladors
    SharedProperties.setSelectedCurs(String(intToStringSeleccioCurs));
  }

  $scope.deleteLabelUrl = (item) => {
    if ($scope.isUrl) {
      var i = $scope.selectionEnsenyament.indexOf(item);
      if (i !== -1) {
        $scope.selectionEnsenyament.splice(i, 1);
        $scope.isUrl = false;
      }
    }
  };

  $scope.isInputChecked = (curs) => {
    return $scope.seleccioCurs.indexOf(curs) > -1;
  };

  $scope.serveisTerritorialTitle = '';

  $scope.selectTypeAhead = ($item, type) => {
    if (type === "SERVEI" && Array.isArray($item)) {
      DataService.comarca.codiComarca = "";
      DataService.comarca.nomComarca = "";
      DataService.comarca.bbox = "";
      DataService.comarca.hideValidation = true;
      //Reset de districte
      DataService.districte.codiDistricte = "";
      DataService.districte.codiServeiTerritorial = "";
      DataService.districte.codiComarca = "";
      DataService.districte.nomDistricte = "";
      DataService.districte.bbox = "";

      //cargar el municipi
      DataService.municipi.codiMunicipi = "";
      DataService.municipi.nomMunicipi = "";
      DataService.municipi.bbox = "";
      DataService.municipi.hideValidation = true;
      var getAllId = '9900';
      var serveisTerritorialIds = '';

      if (!!$item.length) {
        var serveisTerritorial = $item.map((i) => { return i.codiServeiTerritorial || getAllId; });
        if (serveisTerritorial.some((i) => { return i === getAllId })) {
          serveisTerritorial = [getAllId];
        }
        serveisTerritorialIds = serveisTerritorial.join(',')
        $scope.serveisTerritorialTitle = $item
          .map((i) => { return i.nomServeiTerritorial; })
          .filter((i) => { return !!i; })
          .join(', ');
        angular.extend(DataService.serveisTerritorial, { codiServeiTerritorial: serveisTerritorialIds });
      } else {
        serveisTerritorialIds = getAllId;
        $scope.serveisTerritorialTitle = '';
        angular.extend(DataService.serveisTerritorial, { codiServeiTerritorial: '' });
      }

      paramsMunicipis = Municipis.setMunicipisParams([DataService.comarca, { codiServeiTerritorial: serveisTerritorialIds }], paramsMunicipis);
      Municipis.getMunicipis(paramsMunicipis).then((municipis) => {
        $scope.municipis = municipis;
      });
      paramsDistrictes = Districtes.setDistrictesParams([DataService.municipi, DataService.comarca, { codiServeiTerritorial: serveisTerritorialIds }], paramsDistrictes);
      Districtes.getDistrictes(paramsDistrictes).then((districtes) => {
        $scope.districtes = districtes;
      });

      $scope.serveisTerritorial.typeAheadFlag = true;
      $scope.serveisTerritorial.hideValidation = false;
      $scope.serveisTerritorial.inputGroupClass = "input-group";

      $scope.comarca.hideValidation = true;
      $scope.comarca.inputGroupClass = "";
    } else if (type === "SERVEI" && !Array.isArray($item)) {
      $scope.serveisTerritorialTitle = '';
    }

    if (type === "COMARCA" && $item.codiComarca !== "") {
      //informamos el codiComarca
      $scope.comarca.codiComarca = $item.codiComarca;
      $scope.comarca.bbox = $item.bbox; //assignem el bbox
      //reset del ServeisTerritorials
      DataService.serveisTerritorial.codiServeiTerritorial = "";
      DataService.serveisTerritorial.nomServeiTerritorial = "";
      DataService.serveisTerritorial.bbox = "";
      DataService.serveisTerritorial.hideValidation = true;
      $scope.serveisTerritorial = DataService.serveisTerritorial;
      //Reset de districte
      DataService.districte.codiDistricte = null;
      DataService.districte.nomDistricte = "";
      DataService.districte.bbox = "";
      //cargar el municipi
      DataService.municipi.codiMunicipi = "";
      DataService.municipi.nomMunicipi = "";
      DataService.municipi.bbox = ""; //reset del bbox de municipi
      paramsMunicipis = Municipis.setMunicipisParams([DataService.comarca, DataService.serveisTerritorial], paramsMunicipis);
      Municipis.getMunicipis(paramsMunicipis).then((municipis) => {
        $scope.municipis = municipis;
      });
      //carreguem districtes (només retorna valor si comarca és Barcelonès)
      paramsDistrictes = Districtes.setDistrictesParams([DataService.comarca, DataService.serveisTerritorial], paramsDistrictes);
      Districtes.getDistrictes(paramsDistrictes).then((districtes) => {
        $scope.districtes = districtes;
      });
      //se ha modificado via typeahead
      $scope.comarca.typeAheadFlag = true;
      $scope.comarca.hideValidation = false;
      $scope.comarca.inputGroupClass = "input-group";
      $scope.serveisTerritorial.hideValidation = true;
      $scope.serveisTerritorial.inputGroupClass = "";
    }
    if (type === "MUNICIPI" && $item.codiMunicipi !== "") {
      $scope.municipi.codiMunicipi = $item.codiMunicipi;
      $scope.municipi.bbox = $item.bbox; //assignem el bbox
      //Reset de districte
      DataService.districte.codiDistricte = null;
      DataService.districte.nomDistricte = "";
      DataService.districte.bbox = "";
      paramsDistrictes = Districtes.setDistrictesParams(
        [DataService.municipi, DataService.comarca, DataService.serveisTerritorial],
        paramsDistrictes,
      );
      Districtes.getDistrictes(paramsDistrictes).then((districtes) => {
        $scope.districtes = districtes;
      });
      $scope.municipi.typeAheadFlag = true;
      $scope.municipi.hideValidation = false;
      $scope.municipi.inputGroupClass = "input-group";
      //si se informa municpi el centre se busca antes
      $scope.centre.typeaheadMinLength = 1;
    }
    if (type === "DISTRICTE" && $item.codiDistricte !== "") {
      $scope.districte.codiDistricte = $item.codiDistricte;
      $scope.districte.bbox = $item.bbox; //assignem el bbox
      paramsDistrictes = Districtes.setDistrictesParams(
        [DataService.municipi, DataService.comarca, DataService.serveisTerritorial],
        paramsDistrictes
      );
      Districtes.getDistrictes(paramsDistrictes).then((districtes) => {
        $scope.districtes = districtes;
      });
      $scope.districte.typeAheadFlag = true;
    }
    if (type === "CENTRE" && $item.codiCentre !== "") {
      $scope.centre.codiCentre = $item.codiCentre;
      $scope.centre.coordX = $item.coordX;
      $scope.centre.coordY = $item.coordY;
      $scope.centre.hideValidation = false;
      $scope.centre.inputGroupClass = "input-group";
      $scope.centre.typeAheadFlag = true;
    }
  };
  $scope.$watch('centre.nomCentre', (newVal, oldVal) => {
    $scope.centre.codiCentre = null;
    $scope.centre.coordX = "";
    $scope.centre.coordY = "";
    $scope.noResults = false;
    if ($scope.centre.typeAheadFlag) {
      $scope.centre.typeAheadFlag = false;
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast('changeActionButtonText',
          { text: 'Actualitza cerca' });
      }
    } else {
      $scope.centre.hideValidation = true;
      $scope.centre.inputGroupClass = "";
    }
  });

  $scope.$watch('serveisTerritorial.nomServeiTerritorial', (newVal, oldVal) => {
    if (newVal === "") {
      $scope.serveisTerritorial.codiServeiTerritorial = null;
      $scope.serveisTerritorial.nomServeiTerritorial = "";
      $scope.serveisTerritorial.bbox = "";
      $scope.serveisTerritorial.hideValidation = true;
      $scope.serveisTerritorial.inputGroupClass = "";
      $scope.noServeisTerritorial = false;
    }
    if ($scope.serveisTerritorial.typeAheadFlag) {
      $scope.serveisTerritorial.typeAheadFlag = false;
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast('changeActionButtonText', { text: 'Actualitza cerca' });
      }
    } else {
      $scope.serveisTerritorial.codiServeiTerritorial = "";
      $scope.serveisTerritorial.hideValidation = true;
      $scope.serveisTerritorial.inputGroupClass = "";
    }
  });

  $scope.$watch('comarca.nomComarca', (newVal, oldVal) => {
    if (newVal === "") {
      $scope.comarca.codiComarca = null;
      $scope.comarca.nomComarca = "";
      $scope.comarca.bbox = "";
      $scope.comarca.hideValidation = true;
      $scope.comarca.inputGroupClass = "";
      $scope.noComarques = false;
      if (oldVal && (DataService.serveisTerritorial.codiServeiTerritorial === "" || DataService.serveisTerritorial.codiServeiTerritorial == null)) {
        Municipis.init().then((municipis) => {
          $scope.municipis = municipis;
        });
        Districtes.init().then((districtes) => {
          $scope.districtes = districtes;
        });
      }
    }
    if ($scope.comarca.typeAheadFlag) {
      $scope.comarca.typeAheadFlag = false;
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast('changeActionButtonText',
          { text: 'Actualitza cerca' });
      }
    } else {
      $scope.comarca.codiComarca = "";
      $scope.comarca.hideValidation = true;
      $scope.comarca.inputGroupClass = "";
    }
  });

  $scope.$watch('municipi.nomMunicipi', (newVal, oldVal) => {
    $scope.loadingMunicipis = false;
    if (newVal === "") {
      $scope.municipi.codiMunicipi = null;
      $scope.municipi.nomMunicipi = "";
      $scope.municipi.bbox = "";
      $scope.municipi.hideValidation = true;
      $scope.municipi.inputGroupClass = "";
      $scope.noMunicipis = false;

      //Reset dels districtes quan canviem municipi
      $scope.districte.codiDistricte = null;
      $scope.districte.nomDistricte = "";
      $scope.districte.bbox = "";
      $scope.districte.hideValidation = true;
      $scope.districte.inputGroupClass = "";

      //Carreguem els districtes amb tots els possibles paràmetres. Si són null o "" farà un findAll
      paramsDistrictes = Districtes.setDistrictesParams(
        [DataService.municipi, DataService.comarca, DataService.serveisTerritorial],
        paramsDistrictes
      );
      Districtes.getDistrictes(paramsDistrictes).then((districtes) => {
        $scope.districtes = districtes;
      });

    }
    if ($scope.municipi.typeAheadFlag) {
      $scope.municipi.typeAheadFlag = false;
      $scope.centre.typeaheadMinLength = 1;
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast('changeActionButtonText', { text: 'Actualitza cerca' });
      }
    } else {
      $scope.municipi.codiMunicipi = "";
      $scope.municipi.hideValidation = true;
      $scope.municipi.inputGroupClass = "";
    }
  });

  $scope.$watch('districte.nomDistricte', (newVal, oldVal) => {
    $scope.loadingDistricte = false;
    if (newVal === "") {
      $scope.districte.codiDistricte = null;
      $scope.districte.nomDistricte = "";
      $scope.districte.bbox = "";
      $scope.districte.hideValidation = true;
      $scope.districte.inputGroupClass = "";
      $scope.noDistricte = false;
    }
    if ($scope.municipi.typeAheadFlag) {
      $scope.districte.typeAheadFlag = false;
      if ($rootScope.cercaClick) {
        $rootScope.$broadcast('changeActionButtonText', { text: 'Actualitza cerca' });
      }
    } else {
      $scope.districte.hideValidation = true;
      $scope.districte.inputGroupClass = "";
    }
  });

  $scope.$watch('cercarPer', (newVal, oldVal) => {
    DataService.cercarPer = newVal;
    $rootScope.$broadcast('cercarPer');
    if (newVal === 2) {
      $scope.centre.codiCentre = "";
      $scope.centre.nomCentre = "";
      $scope.centre.hideValidation = true;
      $scope.centre.readOnly = true;
    } else {
      $scope.centre.readOnly = false;
    }
  });

  $scope.getCentreMinLength = () => {
    return $scope.centre.typeaheadMinLength;
  };

  $scope.deleteLabel = (item, llista, sel) => {
    var i = llista.indexOf(item);
    if (i !== -1) {
      llista.splice(i, 1);
      if (sel === 'tipus') {
        $scope.selTipusEnsenyament = llista;
      }
      if (sel === 'nivell') {
        $scope.selNivell = llista;
      }
      if (sel === 'naturalesa') {
        $scope.selNaturalesa = llista;
      }
    }
  };

  $scope.getNomCentresAhead = (value) => {
    paramsMapes.codiServeiTerritorial = $scope.serveisTerritorial.codiServeiTerritorial;
    paramsMapes.codiComarca = $scope.comarca.codiComarca;
    paramsMapes.codiMunicipi = $scope.municipi.codiMunicipi;
    paramsMapes.codiDistricte = $scope.districte.codiDistricte;
    const isName = !(/^\d+$/.test(value));

    if (isName) {
      paramsMapes.nom = value;
      paramsMapes.codiCentre = null;
    } else {
      paramsMapes.nom = null;
      paramsMapes.codiCentre = value;
    }

    switch ($scope.selectedTab) {
      case 0:
        return CentresPreinscripcio.getNomCentresPreinscripcioAhead(paramsMapes).then((centres) => {
          return getTypeaheadResults(centres, isName);
        });
      case 1:
        return Centres.getNomCentresAhead(paramsMapes).then((centres) => {
          return getTypeaheadResults(centres, isName);
        });
      case 2:
        return ServeisEducatius.getNomCentresAhead(paramsMapes).then((centres) => {
          return getTypeaheadResults(centres, isName);
        });
    }
  };

  const getTypeaheadResults = (centres, isName) => {
    const result = centres.map((value) => ({
      resultValue: isName ? (value.resultValue || value.nomCentre) : value.codiCentre,
      codiCentre: value.codiCentre
    }))
    $scope.lastMatchesFromNameInput = isName ? removeDuplicates(result, 'resultValue') : result;

    return $scope.lastMatchesFromNameInput;
  }
 
  function resetCommonFilter() {
    DataService.reset();
    mapesOl.cleanMap();
    $rootScope.cercaClick = false;
  }

  function resetOfertaFilter() {
    EnsenyamentsData.reset();
    $scope.ariFilter = [];
    //Repleguem els ul que estiguin oberts
    $('div#cercaAvancada').find("ul").filter(() => {
      if ($(this).css('overflow') === 'hidden') {
        $(this).slideUp();
      }
    });
    //Amaguem la cerca avançada, si escau
    if ($("#cercaAvancada").css("display") !== "none") {
      $("#cercaAvancada").hide();
    }
  }

  function resetAllFilters() {
    //Resetegem el filtre comú(Formulari de dalt)
    resetCommonFilter();
    $rootScope.$broadcast('changeActionButtonText', { text: 'Cerca' });
    // En funció de la pestanya on estiguem, resetegem un filtre o un altre
    if ($scope.selectedTab === 0) {
      $rootScope.$broadcast('clearAdvancedFilter');
    } else {
      resetOfertaFilter();
    }

    angular.extend($scope, DataService.getData());
    NotificationsService.closeMessage();


    $scope.totalItems = 0;
  }

  //Quan salta un broadcast 'clear' es neteja qualsevol missatge d'error i es fa set del selector en fx de progEnabled
  $scope.$on('clear', () => {
    resetAllFilters();
  });

  $scope.changeMapTab = function (tab) {
    switch (tab) {
      case 0:
        $scope.selectedMapTab = 0;
        break;
    }
  };

  $scope.centerCentreOnMap = (data, bboxObj, layer) => {
    if ($scope.selectedTab === 0) {
      if (data.hasOwnProperty('estudisCentre')) {
        updatePreinscripcioMapWithResults(data.estudisCentre, bboxObj);
      } else {
        updateMap(data.filter, bboxObj, $scope.selectedTab, data.dataGeoserver);
      }
    } else if ($scope.selectedTab === 1) {
      mapesOl.updateMapGeoserver(data.filter, bboxObj, layer || params.geoServerOfertaLayers);
    } else {
      mapesOl.updateMapGeoserver(data.filter, bboxObj, layer || params.geoServerServeisEducatiusLayersTwo);
    }
    $scope.selectedMapTab = 0;
  };

  //Funció que elimina els duplicats d'una llista d'objectes en funció del camp especificat (prop)
  function removeDuplicates(arr, prop) {
    var new_arr = [];
    var lookup = {};

    Object.keys(arr).forEach((i) => {
      lookup[arr[i][prop]] = arr[i];
    });

    Object.keys(lookup).forEach((i) => {
      new_arr.push(lookup[i]);
    });

    return new_arr;
  }

  function conversioAccents(s) {
    if (!s) {
      return '';
    }
    return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  $scope.filterComarcaWithoutAccents = (value) => {
    return (item) => {
      if (item.nomComarca === null) {
        return;
      }
      var text = conversioAccents(item.nomComarca.toLowerCase());
      var cerca = conversioAccents(value.toLowerCase());
      return text.indexOf(cerca) > -1;
    }
  };

  $scope.filterMunicipiWithoutAccents = (value) => {
    return (item) => {
      if (item.nomMunicipi === null) {
        return;
      }
      var text = conversioAccents(item.nomMunicipi.toLowerCase());
      var cerca = conversioAccents(value.toLowerCase());
      return text.indexOf(cerca) > -1;
    }
  };

  $scope.filterDistricteWithoutAccents = (value) => {
    return (item) => {
      if (item.nomDistricte === null) {
        return;
      }
      var text = conversioAccents(item.nomDistricte.toLowerCase());
      var cerca = conversioAccents(value.toLowerCase());
      return text.indexOf(cerca) > -1;
    }
  };

  $scope.goToCentre = function (centre) {
    if (centre !== undefined) {
      $uibModal.open(
        {
          animation: true,
          component: 'ajFitxaCentre',
          size: 'xl',
          resolve: { centre: { codiCentre: centre } },
        }
      );
    }
  }
})
